import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { statusfarben, eskalationsLevel } from "./globalVariables";
import { useConfig } from "./ConfigContext";

function MyTabs({ datenblattkacheln, projektstufe, setSelectedKachel, checkSpeichern, eskstatus, basicdata }) {
   const config = useConfig();
   const [projektstufenStatus, setProjektstufenStatus] = useState(false);
   useEffect(() => {
      let currentPS = {};
      Object.keys(datenblattkacheln).forEach((stufen_key) => {
         currentPS[stufen_key] = 0;
         // Eskalationsstatus geht vor, ansonsten soll der niedrigste Kachelstatus der Projektstufe zurückgegeben werden
         let maxKachelStufe = 0;
         let minKachelStufe = 4;
         Object.values(datenblattkacheln[stufen_key].kachel).some((kachel) => {
            const kachelStatus = eskstatus["kachel_status_" + kachel.kachelId];
            const kachelEskDatum = eskstatus["kachel_eskalation_" + kachel.kachelId];
            if (kachelStatus < eskalationsLevel && kachelEskDatum && new Date(kachelEskDatum) < new Date()) {
               //Kachel eskaliert -- Projektstufe soll eskalieren
               /* maxKachelStufe = 9;
               minKachelStufe = 0; */
               maxKachelStufe = -1;
               minKachelStufe = -1;
               return true;
            } else if (kachelStatus < 4) {
               //Kachel eskaliert nicht -- Projektstatus soll mindestens den Kachelstatus haben
               maxKachelStufe = Math.max(maxKachelStufe, kachelStatus);
            }

            if (typeof kachelStatus !== "undefined") {
               //Kachel eskaliert nicht -- Projektstatus soll maximal den Kachelstatus haben

               minKachelStufe = Math.min(minKachelStufe, kachelStatus);
            }
         });

         currentPS[stufen_key] = minKachelStufe < 4 ? maxKachelStufe : minKachelStufe;
      });
      console.log(currentPS);

      setProjektstufenStatus(currentPS);
   }, [eskstatus]);
   return (
      <>
         <ul className="nav nav-tabs mb-2">
            {Object.keys(datenblattkacheln).map((projektstufe_key, index) => (
               <li className="nav-item" key={projektstufe_key}>
                  <button
                     style={{
                        opacity: eskstatus?.["projekt_status_" + projektstufe_key] >= 9 ? 0.3 : 1,
                     }}
                     disabled={eskstatus?.["projekt_status_" + projektstufe_key] >= 9}
                     className={
                        "nav-tab " +
                        "nav-link" +
                        (projektstufe_key === projektstufe ? " active" : "") +
                        (projektstufenStatus[projektstufe_key] === -1 ? " tab-eskaliert" : "")
                     }
                     title={datenblattkacheln[projektstufe_key].projektHeading}
                     aria-current="page"
                     onClick={(e) => {
                        console.log(projektstufe_key);
                        checkSpeichern(projektstufe_key, "tab");
                     }}
                  >
                     {projektstufe_key === projektstufe && datenblattkacheln[projektstufe_key].projektHeading}
                     {projektstufe_key != projektstufe && (
                        <div>
                           <div className="nav-tab-name-desktop">
                              {datenblattkacheln[projektstufe_key].projektKurzel}
                              <div style={{ position: "relative", width: 0, height: 0 }}>
                                 <span className="nav-helper">
                                    {datenblattkacheln[projektstufe_key].projektHeading}
                                 </span>
                              </div>
                           </div>
                           <span className="nav-tab-name-mobile">
                              {datenblattkacheln[projektstufe_key].projektHeading}
                           </span>
                        </div>
                     )}
                     <div
                        className="tab-status"
                        style={{
                           backgroundColor: statusfarben[projektstufenStatus[projektstufe_key]?.toString()],
                        }}
                     ></div>
                  </button>
               </li>
            ))}
         </ul>
      </>
   );
}

export default MyTabs;
